import type { AnalysisType } from "@/generated/graphql"
import { Animated, View, type ViewStyle } from "react-native"
import React from "react"
import useDeviceAttributes from "@/hooks/useDeviceAttributes"
import { BFColors } from "@/constants/Colors"
import AnalysisHeaderCompact from "@/components/analysis/AnalysisHeaderCompact"
import { HEADER_HEIGHT } from "@/components/analysis/header/StretchyHeader"

interface SmallStickyPropertyHeaderProps {
  analysis: AnalysisType | null
  scrollY: Animated.Value
}

export const SmallStickyPropertyHeader: React.FC<
  SmallStickyPropertyHeaderProps
> = ({ analysis, scrollY }) => {
  // Calculate paddingTop based on whether there is a notch or not
  const { hasNotch } = useDeviceAttributes()
  const additionalPadding = hasNotch ? 20 : 0
  const height = HEADER_HEIGHT - 115 + additionalPadding
  const start = HEADER_HEIGHT - height
  const length = 40

  // const stickyHeaderTranslate = scrollY.interpolate({
  //   inputRange: [start - length, start],
  //   outputRange: [-height, 0],
  //   extrapolate: "clamp",
  // })

  const stickyHeaderStyle: ViewStyle = {
    // transform: [{ translateY: stickyHeaderTranslate }],
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: BFColors.offWhite,
    height,
    alignItems: "center",
    opacity: scrollY.interpolate({
      inputRange: [start - length, start],
      outputRange: [0, 1],
      extrapolate: "clamp",
    }),
    paddingVertical: 6,
    pointerEvents: "none",
    zIndex: 10,
  }

  return (
    <Animated.View style={stickyHeaderStyle}>
      <View className="flex items-center self-center w-full">
        <AnalysisHeaderCompact
          // @ts-expect-error "Almost correct Analysis Types disagree"
          analysis={analysis}
        />
      </View>
    </Animated.View>
  )
}
